import React, { lazy } from 'react';
interface ChatBlurbProps {
  name: string;
  role: string;
  message: string;
  avatarUrl: string;
  position: 'left' | 'right' | 'center';
}
export function ChatBlurb({
  name,
  role,
  message,
  avatarUrl,
  position
}: ChatBlurbProps) {
  const positionClasses = {
    left: 'left-1 md:left-4 lg:left-8 top-[15%] md:top-1/4',
    right: 'right-1 md:right-4 lg:right-8 top-[20%] md:top-1/3',
    center: 'right-1 md:right-4 lg:right-8 top-[45%] md:top-[55%]'
  };
  return <div className={`absolute ${positionClasses[position]} z-20 animate-float`} style={{
    animationDelay: position === 'left' ? '0s' : position === 'right' ? '0.5s' : '1s'
  }} data-id="element-89">
      <div className="bg-white rounded-xl md:rounded-2xl shadow-2xl p-1.5 md:p-2 lg:p-3 max-w-[100px] md:max-w-[160px] lg:max-w-[200px] hover:scale-105 transition-transform duration-300" data-id="element-90">
        <div className="flex items-start gap-1 md:gap-1.5 lg:gap-2" data-id="element-91">
          <img src={avatarUrl} alt={name} className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 rounded-full object-cover flex-shrink-0 ring-1 md:ring-2 ring-blue-100" loading="lazy" data-id="element-92" />
          <div className="flex-1 min-w-0" data-id="element-93">
            <div className="flex items-center gap-0.5 md:gap-1 mb-0.5" data-id="element-94">
              <p className="text-[8px] md:text-[10px] lg:text-xs font-bold text-gray-900 truncate" data-id="element-95">
                {name}
              </p>
              <span className="text-green-500 text-[8px] md:text-[10px] lg:text-xs" data-id="element-96">
                ✓
              </span>
            </div>
            <p className="text-[7px] md:text-[8px] lg:text-[10px] text-gray-500 mb-0.5 truncate" data-id="element-97">
              {role}
            </p>
            <p className="text-[7px] md:text-[9px] lg:text-xs text-gray-700 leading-tight line-clamp-2" data-id="element-98">
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>;
}